module.exports = function() {
  return new Worker(__webpack_public_path__ + "df02a7d3fc14c526c181.worker.js");
};